/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Planner_CostInputs */

const en_planner_cost = /** @type {(inputs: Planner_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.cost} in total`)
};

const de_planner_cost = /** @type {(inputs: Planner_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.cost} gesamt`)
};

/**
* | output |
* | --- |
* | "≈ {cost} in total" |
*
* @param {Planner_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_cost = /** @type {((inputs: Planner_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_cost(inputs)
	return en_planner_cost(inputs)
});